var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echartsBox"},[_c('img',{staticClass:"imggif",attrs:{"src":require("@/assets/RN/gifdc.gif"),"alt":""}}),_c('div',{ref:"huanxing",style:({ width: '435px', height: '240px' }),attrs:{"id":"huanxing"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }